export const VOICE_LANGS = [
  { code: "en", bcp: "en-US", name: "English", quality: "Excellent" },
  { code: "ar", bcp: "ar-SA", name: "العربية", quality: "Very good" },
  { code: "hi", bcp: "hi-IN", name: "हिन्दी", quality: "Good" },
  { code: "ur", bcp: "ur-PK", name: "اردو", quality: "Fair – may be slower" },
  { code: "fr", bcp: "fr-FR", name: "Français", quality: "Excellent" },
  { code: "es", bcp: "es-ES", name: "Español", quality: "Excellent" },
  { code: "bn", bcp: "bn-BD", name: "বাংলা", quality: "Fair – may be slower" },
  { code: "ml", bcp: "ml-IN", name: "മലയാളം", quality: "Fair – voice may be missing" },
  { code: "tl", bcp: "tl-PH", name: "Filipino", quality: "Fair – voice may be missing" },
  { code: "ne", bcp: "ne-NP", name: "नेपाली", quality: "Limited – voice may be missing" },
  { code: "ru", bcp: "ru-RU", name: "Русский", quality: "Very good" },
  { code: "zh", bcp: "zh-CN", name: "中文", quality: "Very good" },
];

export const bcpOf = (code) => VOICE_LANGS.find((l) => l.code === code)?.bcp || "en-US";

export function findVoice(code) {
  if (!("speechSynthesis" in window)) return null;
  const bcp = bcpOf(code).toLowerCase();
  const voices = window.speechSynthesis.getVoices();
  return voices.find((v) => v.lang.toLowerCase() === bcp) ||
    voices.find((v) => v.lang.toLowerCase().startsWith(code)) || null;
}

export function speak(text, code, rate = 1, handlers = {}) {
  if (!("speechSynthesis" in window)) {
    handlers.onend?.();
    return { ok: false, hasVoice: false };
  }
  window.speechSynthesis.cancel();
  const u = new SpeechSynthesisUtterance(text);
  u.lang = bcpOf(code);
  u.rate = rate;
  const v = findVoice(code);
  if (v) u.voice = v;
  u.onstart = () => handlers.onstart?.();
  u.onend = () => handlers.onend?.();
  u.onerror = () => handlers.onend?.();
  window.speechSynthesis.speak(u);
  return { ok: true, hasVoice: !!v };
}

export const stopSpeaking = () => window.speechSynthesis?.cancel();

export function getRecognizer(code) {
  const SR = window.SpeechRecognition || window.webkitSpeechRecognition;
  if (!SR) return null;
  const r = new SR();
  r.lang = bcpOf(code);
  r.interimResults = true;
  r.maxAlternatives = 1;
  return r;
}
